export default function preventLinksInEditor(){
    // Prevent link elements from changing the page while in the editor.
    document.addEventListener('click', function (e) {
        if ((e.target.matches('a') || e.target.closest('a')) && e.target.closest('.editor-styles-wrapper')){
            e.preventDefault();
        }
    }, false);
}